@if (!loading() && sirena) {
  <app-breadcrumb
    listado="/main/sirenas/sirenas"
    etiquetaListado="Sirenas"
    [titulo]="sirena?.chipId"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>campaign</mat-icon></div>
    <div class="encabezado-texto">
      <h1 class="sirena-chip">{{ sirena.chipId || 'Sirena' }}</h1>
      @if (sirena.direccionGps) {
        <span class="encabezado-nombre">{{ sirena.direccionGps }}</span>
      }
      <div class="encabezado-chips">
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="sirena-info">
          <!-- Resumen: conexión y lo que está haciendo la sirena -->
          <app-dt-card>
            <app-dt-datos destacado>
              <app-dt-dato etiqueta="Conexión" ocultarVacio>
                <app-dt-estado
                  [tono]="sirena.online ? 'ok' : 'apagado'"
                  [etiqueta]="sirena.online ? 'En línea' : 'Sin conexión'"
                />
              </app-dt-dato>
              <app-dt-dato etiqueta="Activa" [valor]="siNo(sirena.activa)" />
              <app-dt-dato
                etiqueta="Sonido"
                [valor]="encendido(sirena.sonidoEncendido)"
              />
              <app-dt-dato
                etiqueta="Luz"
                [valor]="encendido(sirena.luzEncendida)"
              />
            </app-dt-datos>
          </app-dt-card>

          <div class="sirena-grilla">
            <app-dt-card titulo="Equipo" icono="campaign">
              <app-dt-datos>
                <app-dt-dato etiqueta="Tipo" [valor]="sirena.tipo" />
                <app-dt-dato etiqueta="Modelo" [valor]="sirena.modeloSirena" />
                <app-dt-dato
                  etiqueta="Versión de firmware"
                  [valor]="sirena.versionFirmware"
                  mono
                />
                <app-dt-dato
                  etiqueta="Instalada en"
                  [valor]="sirena.instaladaEn"
                />
                <app-dt-dato
                  etiqueta="En línea desde"
                  [valor]="fecha(sirena.fechaOnline)"
                />
                <app-dt-dato
                  etiqueta="Sin conexión desde"
                  [valor]="fecha(sirena.fechaOffline)"
                />
              </app-dt-datos>
            </app-dt-card>

            <app-dt-card titulo="Señal y SIM" icono="sim_card">
              <app-dt-datos>
                <app-dt-dato
                  etiqueta="IMEI"
                  [valor]="sirena.imei"
                  mono
                  copiable
                />
                <app-dt-dato
                  etiqueta="ICCID de la SIM"
                  [valor]="sirena.iccidSim"
                  mono
                  copiable
                />
                <app-dt-dato etiqueta="RSSI" [valor]="numero(sirena.rssi)" />
                <app-dt-dato etiqueta="BER" [valor]="numero(sirena.ber)" />
                <app-dt-dato
                  etiqueta="Wakeup"
                  [valor]="numero(sirena.wakeup)"
                />
              </app-dt-datos>
            </app-dt-card>
          </div>

          <!-- Mapa con ubicación: si hay coordenadas resueltas -->
          @if (mapOptions) {
            <app-map-card
              title="Ubicación"
              icon="location_on"
              color="red"
              [showShadow]="false"
              [mapOptions]="mapOptions"
              height="320px"
            ></app-map-card>
          }
        </div>
      </ng-template>
    </mat-tab>

    <!-- Asignaciones (SIM) -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="sirena._id"
          tipoEntidad="modificada"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else if (!loading()) {
  <app-breadcrumb
    listado="/main/sirenas/sirenas"
    etiquetaListado="Sirenas"
    [titulo]="sirena?.chipId"
  ></app-breadcrumb>
  <app-empty-state
    icon="campaign"
    message="No se encontraron datos de la sirena."
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto
    icono="campaign"
    listado="/main/sirenas/sirenas"
    etiquetaListado="Sirenas"
    [pestanas]="2"
  ></app-detalle-esqueleto>
}
